import React, { forwardRef } from "react"
import { Button } from "react-bootstrap"
import "./style.css"

const ApprovalStatusButton = forwardRef(({ variant, children, style, ...rest }, ref) => (
  <Button
    ref={ref}
    variant={variant}
    size="sm"
    block
    style={{ borderWidth: "2px", ...style }}
    className="no-hover"
    {...rest}>
    <b>{children}</b>
  </Button>
))

export default ApprovalStatusButton
